module.exports = __webpack_public_path__ + "static/GladTrashBags-3a3fba7c51a74ed447fbc171aeeeac74.jpg";